/**
 * Format Money v1.0.0
 * ═══════════════════════════════════════════════════════════════════════════════
 *
 * Formats cents to money string using Shopify's money format.
 * Extracted from cart store (Issue #11 sub-fix 7a).
 *
 * Exposed on window.Theme.formatMoney for use by:
 * - Alpine store: $store.cart.formatMoney(cents)
 * - Alpine magic: $money(cents)
 * - ES Module bridge: @theme/format-money
 *
 * Supports four money format patterns (US and EU conventions):
 * - amount:             1,234.56 (US)
 * - amount_no_decimals: 1,234 (US)
 * - amount_with_comma_separator: 1.234,56 (EU)
 * - amount_no_decimals_with_comma_separator: 1.234 (EU)
 *
 * ═══════════════════════════════════════════════════════════════════════════════
 */

(function () {
  'use strict';

  window.Theme = window.Theme || {};

  /**
   * Format cents to money string using shop format.
   * Matches Shopify.formatMoney exactly.
   *
   * @param {number|string} cents - Amount in cents (e.g., 123456 → "$1,234.56")
   * @param {string} format - Money format template from Shopify settings
   *                          (e.g., "${{amount}}" or "{{amount_with_comma_separator}}")
   * @returns {string} Formatted money string (e.g., "$1,234.56")
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = parseInt(cents.replace(/[^0-9-]/g, ''));
    }
    if (isNaN(cents) || cents == null) {
      return '';
    }

    // Get format from settings (set by theme.liquid SSR data) or default
    const formatStr = format || window.Theme?.shopify?.moneyFormat || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    const dollars = parts[0];
    const centsStr = parts[1];

    // Thousands separator patterns
    const withDotThousands = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // EU: 1.234
    const withCommaThousands = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // US: 1,234

    return formatStr
      .replace(/\{\{\s*amount\s*\}\}/g, withCommaThousands + '.' + centsStr) // US: 1,234.56
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommaThousands) // US: 1,234
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDotThousands + ',' + centsStr) // EU: 1.234,56
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withDotThousands); // EU: 1.234
  }

  window.Theme.formatMoney = formatMoney;
})();
